import { useEffect } from "react";

function useOutsideClick(ref, action, dispatch) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // the setTimeout is used to debounce the action: sometimes the action interferes with other actions causing bugs
        setTimeout(() => {
          dispatch(action);
        }, 200);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, dispatch]);
}

export default useOutsideClick; 